// Personalizações para lojas brasileiras (sobre o tema Dawn).

// <br-prazo-entrega data-min="7" data-max="15">: troca "7 e 15 dias úteis"
// pelas datas previstas ("12 de out. e 22 de out."), contando só dias úteis.
if (!customElements.get('br-prazo-entrega')) {
  const somarDiasUteis = (inicio, dias) => {
    const data = new Date(inicio);
    let contados = 0;
    while (contados < dias) {
      data.setDate(data.getDate() + 1);
      const diaSemana = data.getDay();
      if (diaSemana !== 0 && diaSemana !== 6) contados++;
    }
    return data;
  };

  customElements.define(
    'br-prazo-entrega',
    class BrPrazoEntrega extends HTMLElement {
      connectedCallback() {
        const min = parseInt(this.dataset.min, 10);
        const max = parseInt(this.dataset.max, 10);
        const alvo = this.querySelector('[data-datas]');
        if (!alvo || !min || !max) return;

        const formato = new Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'short' });
        const hoje = new Date();
        alvo.textContent = `${formato.format(somarDiasUteis(hoje, min))} e ${formato.format(somarDiasUteis(hoje, max))}`;
      }
    }
  );
}
